import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import { Category } from 'components/CategoryNavCarousel'
import { CategoryNavCarouselItem } from 'components/CategoryNavCarousel/CategoryNavItem'
import { CategoryNavItem } from './CategoryNavItem'

type CategoryNavItemWrapperProps = {
  category: Category
  slug?: string
  pathCategory: (slug: string) => string
  onNavClick?: (category: Category) => void
}

export const CategoryNavItemWrapper = ({
  category,
  slug,
  pathCategory,
  onNavClick,
}: CategoryNavItemWrapperProps) => {
  const { pathname } = useRouter()

  if (pathname.includes(paths.articles)) {
    return (
      <CategoryNavCarouselItem
        category={category}
        slug={slug}
        pathCategory={pathCategory}
        onNavClick={onNavClick}
      />
    )
  }

  return (
    <CategoryNavItem
      category={category}
      slug={slug}
      pathCategory={pathCategory}
      onNavClick={onNavClick}
    />
  )
}
